export const Breadcrumbs = {
	breadcrumbsText: 'var(--epods--breadcrumbs-base-font-color)',
	breadcrumbsSeparatorFill: 'var(--epods--breadcrumbs-separator-color)',
};

export const CustomBreadcrumbs = {
	baseFont: 'var(--epods--breadcrumbs-base-font)',
	baseFontSize: 'var(--epods--breadcrumbs-base-font-size)',
	baseFontHeight: 'var(--epods--breadcrumbs-base-font-height)',

	separatorMargin: 'var(--epods--breadcrumbs-separator-margin)',
	separatorColor: 'var(--epods--breadcrumbs-separator-color)',
};
